import useSWR from 'swr'
import { useAuth } from '../store/auth.store'
import { NotificationService } from '../services/notifications.service'

const fetchData = async (
  userId: string | number,
): Promise<INotification[]> => {
  return await NotificationService.getNotification(userId)
}

const useDataNotifications = () => {
  const { user } = useAuth()
  const isDisabled = user?.permission?.permissionDetaileds[0]?.isServiceView &&
                     user?.permission?.permissionDetaileds[0]?.isOrdersView

  const { data, error, isLoading, mutate } = useSWR<INotification[]>(
    isDisabled ? `/client/notification/${user?.id}` : null,
    () => fetchData(user!.id)
  )

  const readNotification = async (id: string | number) => {
    await NotificationService.readNotification(id)
    mutate()
  }

  const readAllNotification = async () => {
    await NotificationService.readAllNotifications(user!.id)
    mutate()
  }
  
  return {
    data,
    isLoading,
    isError: error,
    mutate,
    readNotification,
    readAllNotification
  }
}

export default useDataNotifications

